'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialTables$$anon$21() {
}
export { $c_Lpresto_CredentialTables$$anon$21 as $c_Lpresto_CredentialTables$$anon$21 };
$p = $c_Lpresto_CredentialTables$$anon$21.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialTables$$anon$21;
/** @constructor */
function $h_Lpresto_CredentialTables$$anon$21() {
}
export { $h_Lpresto_CredentialTables$$anon$21 as $h_Lpresto_CredentialTables$$anon$21 };
$h_Lpresto_CredentialTables$$anon$21.prototype = $p;
$p.b6 = (function(_$67) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$67, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$68) => {
    var this$2 = _$68.iw.xe;
    return (this$2.k() ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$() : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some(this$2.q().xs));
  })), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_math_Ordering$O$1($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().pa()));
});
var $d_Lpresto_CredentialTables$$anon$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialTables$$anon$21, "presto.CredentialTables$$anon$21", ({
  FF: 1,
  G: 1
}));
export { $d_Lpresto_CredentialTables$$anon$21 as $d_Lpresto_CredentialTables$$anon$21 };
//# sourceMappingURL=presto.-Credential-Tables$$anon$21.js.map
